export default "__VITE_ASSET__D4xkxjk0__"